import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=6996af59&"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./ProfilePhoto.vue?vue&type=style&index=1&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports